<template>
  <div :loading="loading" class="box">
    <!-- <a-row>
      <a-col :span="5" v-if="isPad">
        <patient-info-card :patient="patient" :is-pad="isPad" class="patient-info-card">
          <a-row class="info-row" style="margin-top: 5px">
            <a-col :span="12" class="center-panel">
              <a-button style="width: 95%" type="primary" :size="isPad?'small':'default'" @click="handleView"> 详细资料 </a-button>
            </a-col>
            <a-col :span="12" class="center-panel">
              <status-tag :status="patient.status"></status-tag>
            </a-col>
          </a-row>
        </patient-info-card>
      </a-col>
      <a-col :span="isPad?19:24">
        <div>
          选择周期：<a-select v-model="selectedKey" style="width: 300px;margin-bottom: 10px" @change="handleChange">
          <a-select-option :value="item.id" v-for="(item,index) in followList" :key="index" >
            {{item.name}}
          </a-select-option>
        </a-select>
        </div>
        <a-row class="follow-row center-panel" >
          <a-col :span="isPad?7:6" v-for="(item,index) in followList" :key="index"  >
            <follow-period-card  :data="item" style="width: 90%;margin-bottom: 5px" :selected="selected(item)" @click="selectChange(item)"></follow-period-card>
          </a-col>
          <a-col :span="isPad?10:6" v-if="patient.createdPeriod!=='1'">
            <div style="width: 100%; margin-bottom: 5px;border: 1px solid rgba(0,0,0,0.2);
    border-radius: 10px;padding: 7px;">
              <div style="line-height: 50px">
                暂未生成随访计划，如需生成请点击【启动随访】
              </div>
              <div style="line-height: 50px;">
                <a-button type="primary" @click="startPeriodHandle">启动随访</a-button>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>  -->

    <div class="wrap">
      <div class="top1">
        <div class="left">
          <img :src="require(`@/assets/${patient.sex === '0' ? 'lady' : 'gentlemen'}.jpg`)" width="48" height="48" alt="">
          <div class="info">
            <div class="detail">
              <strong>{{ patient.name }}</strong>
              <a-tag color="rgba(55, 110, 255, 1)">
                {{ patient.sex == '1' ? '男' : '女' }}
              </a-tag>
              <a-tag color="rgba(193, 200, 216, 1)">
                {{ patient.age }}岁
              </a-tag>
              <status-tag :status="patient.status" :showIcon="patient.status=='4'" @statusClick="statusClick"></status-tag>              
            </div>
            <div class="serial-number">受试者编号 {{ patient.patientNum }}</div>
          </div>
        </div>
        <div class="middle">
          <a-row class="row1">
            <a-col :span="4">
              <span>身份证号</span>
              <strong>{{ getIdcardStr() }}</strong>
            </a-col>
            <a-col :span="6" v-if="fieldList2.length !== 0">
              <span>{{ fieldList2.length !== 0 && fieldList2[0].name }}</span>
              <strong>{{ fieldList2.length !== 0 && fieldList2[0].value }}</strong>
            </a-col>
            <a-col :span="6" v-if="getteleTypeName(patient.teleType1)!='无'">
              <span>  {{getteleTypeName(patient.teleType1)}}</span>
              <strong>{{patient.telephone1}}</strong>
            </a-col>
            <a-col :span="6" v-if="getteleTypeName(patient.teleType2)!='无'">
              <span>  {{getteleTypeName(patient.teleType2)}}</span>
              <strong>{{patient.telephone2}}</strong>
            </a-col>
<!--            <a-col :span="6">
              <span>配偶联系方式</span>
              <strong>暂无</strong>
            </a-col>-->
          </a-row>
        </div>
        <div class="right">
          <a-button @click="handleView">详细资料</a-button>
        </div>
      </div>
      <div class="line"></div>
      <div class="main">
        <div class="left">          
          <div class="tab-container2" v-if="this.period.groupSet !='0'">
            <div class="tab-header2" ref="tabHeader2">
              <a-tabs v-model="tabActiveKey" @change="groupChange">
                <a-tab-pane v-for="(tab,index) in followGroupList" :key="index" :tab="renderTab(tab)"></a-tab-pane>
              </a-tabs>
            </div>
          </div>
          <div :class="['item','container',cur === index && 'cur']" v-for="(item, index) in periodList" :key="index" @click="selectChange(item);cur = index">
            <custom-pie :id="'list'+index" :percent="item.progress" width="100px"></custom-pie>
            <div class="info">
              <div class="icon" @click="editPeriodMark(item)">
                <edit :width="'18px'"></edit>
              </div>
              <strong class="title">{{ item.name }}</strong>
              <div class="status">
                <span class="sp1">表单数量</span>
                <span class="sp2">{{ item.formCount }}</span>
                <period-status-tag :status="item.status"></period-status-tag>
              </div>
              <div class="time">
                <span>节点周期</span>
                <strong>{{ item.startDate }} ~ {{ item.endDate }}</strong>
              </div>
            </div>
            <div class="icon-container">              
              <div id="editIcon" class="icon" @click="editPeriod(item)" v-if="item.isCopy==='1' && item.groupStatus !='2'" v-has="'patient:period:copy'">
                <edit :width="'18px'"></edit>
              </div> 
              <div id="copyIcon" class="icon" @click="copyPeriod(item)" v-if="item.isCopy==='1' && item.groupStatus !='2'" v-has="'patient:period:copy'">
                <copy :width="'18px'"></copy>
              </div> 
              <div id="delIcon" class="icon" @click="delPeriod(item)" v-if="item.isCopy==='1' && item.groupStatus !='2'" v-has="'patient:period:copy'">              
                <delete-icon :width="'18px'"></delete-icon>
              </div>
              <div class="icon" @click="editPeriodVisitDate(item)" v-if="(item.commonFlag & 1)===1 && item.groupStatus !='2'">
                <edit :width="'18px'" :strokeColor="'#3b7435'"></edit>
              </div>       
              <!-- <ul id="dropdown-menu" v-if="item.isCopy==='1'" v-has="'patient:period:copy'">
                <li @click="copyPeriod(item.id)">复制随访周期</li>
                <li @click="delPeriod(item.id)">删除随访周期</li>
              </ul> -->
            </div>
          </div>
        </div>
        <div class="line-vertical"></div>
        <div class="right">
          <div class="btn">
            <a-button type="primary" v-if="this.period.groupSet !='0'" @click="groupTypeHandle">添加{{this.period.groupTypeName}}</a-button> 
            <slot name="btn-left"></slot>
            <a-button v-if="getCurrentPeriod().halfway === '1'" @click="handleEditPeriod">删除/编辑计划外周期</a-button>
            <!-- <a-button type="primary" @click="trendView" icon="line-chart">趋势指标</a-button> -->
            <slot name="btn"></slot>
          </div>
          <form-table ref="form-table" class="panel" @unload="loadData" :dataSource="formList"></form-table>
        </div>
      </div>
    </div>
    <trend-modal ref="trendModal" :id="patient.id" :width="isPad ? '100%' : '80%'"></trend-modal>
    <a-modal :title="`修改${projectPeriod.baseName || '基线'}日期`" :width="800" :visible="baseDateView"
      :confirmLoading="loading" @ok="startPeriodOk" @cancel="baseDateView = false">
      {{ projectPeriod.baseName || '基线' }}日期：<a-date-picker value-format='YYYY-MM-DD' v-model="baseDate" />
    </a-modal>
    <period-modal ref="periodModal" @ok="loadData" :patient-id="patient.id"></period-modal>
    <patient-edit ref="patient-edit" :width="isPad ? '100%' : '60%'" :fieldList="fieldList"></patient-edit>
    <a-modal
        :title="`复制访视周期`"
        :width="600"
        :visible="copyPeriodView"
        :confirmLoading="loading"
        @ok="copyPeriodOk"
        @cancel="copyPeriodView = false">
        <a-form-model layout="vertical" :rules="rules">
          <a-form-model-item label="被复制的周期">
            {{copyPeriodItem?copyPeriodItem.name:''}}
          </a-form-model-item>
          <a-form-model-item label="新周期的名称">
            <a-input v-model="copyPeriodName" style="width:15rem" placeholder="可以不填,系统默认自动生成"></a-input>
            <a-tooltip placement="topLeft" style="padding-left:2px">
                <template slot="title">
                  如果填入，系统将按照该名称生成
                </template>
                <a-icon type="info-circle" style="color: #FF4500" />
              </a-tooltip>
          </a-form-model-item>
          <a-form-model-item label="访视日期" prop="periodDate">
            <a-date-picker value-format='YYYY-MM-DD' v-model="followPeriodDate" /> 
          </a-form-model-item>
        </a-form-model>            
      </a-modal>
      <a-modal
        :title="`编辑周期名称`"
        :confirmLoading='loading'
        :width="600"
        :visible="editPeriodView"
        @ok="editPeriodOk"
        @cancel="editPeriodView = false">        
        <a-form-model-item label="周期的名称">
          <a-input v-model="editPeriodName" style="width:15rem"></a-input>
        </a-form-model-item>                     
      </a-modal>
      <a-modal
        :title="`周期备注`"
        :confirmLoading='loading'
        :width="600"
        :visible="markPeriodView"
        @ok="markPeriodOk"
        @cancel="markPeriodView = false">        
        <a-form-model-item label="周期的名称" v-if="copyPeriodItem">
          {{copyPeriodItem.name}}          
        </a-form-model-item>
        <a-form-model-item label="备注" v-if="copyPeriodItem">          
          <a-textarea :rows="2" placeholder="请输入备注" v-model="copyPeriodItem.remark"  class="textarea"/>
        </a-form-model-item>                     
      </a-modal>
      
      <a-modal :title="`终止随访`"
        :confirmLoading='loading'
        :width="600"
        :visible="endPeriodView"       
        @ok="endPeriodView = false" 
        @cancel="endPeriodView = false">
        <div class="filtrate-fail" v-if="patient.status === '4' && endPeriodList.length > 0">
          <div class="fail-title">
            <a-icon type="info-circle" style="color: red" />该病例目前【终止随访】
          </div>
          <div class="fail-info">
            终止日期：{{ endPeriodList[0].createTime }}
          </div>
          <div class="fail-info">
            终止操作人：{{ endPeriodList[0].createName }}
          </div>
          <div class="fail-info">
            终止节点：{{ endPeriodList[0].periodType === '1' ? '基线' : '随访周期' }}
          </div>
          <div class="fail-info">
            终止原因：
          </div>
          <div v-for="(item, index) in endPeriodList" :key="index">
            <template>
              <div class="fail-info" style="margin-left: 34px">
                {{ item.typeText }}
              </div>
              <div class="fail-info" style="margin-left: 50px;">
                {{ item.description }}
              </div>
            </template>
          </div>
        </div>
      </a-modal>
      <a-modal
      :title="`添加${this.period.groupTypeName||'分组'}`"
      :width="500"
      :visible="groupTypeView"
      :confirmLoading="loading"
      @ok="groupTypeOk"
      @cancel="groupTypeView = false">
      <!-- 使用 a-row 和 a-col 创建网格布局 -->
      <a-row :gutter="3">
        <!-- 左上角部分 -->
        <a-col :span="12">
          <a-row :gutter="3">
            <a-col :span="3" v-for="(num, index) in leftTopNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" @click="selectGroup(num)">{{ num }}</div>              
            </a-col>
          </a-row>
          <a-row :gutter="3">
            <a-col :span="3" v-for="(num, index) in leftBottomNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" @click="selectGroup(num)">{{ num }}</div>
            </a-col>
          </a-row>
        </a-col>

        <!-- 右上角部分 -->
        <a-col :span="12">
          <a-row :gutter="3">
            <a-col :span="3" v-for="(num, index) in rightTopNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" @click="selectGroup(num)">{{ num }}</div>
            </a-col>
          </a-row>
          <a-row :gutter="3">
            <a-col :span="3" v-for="(num, index) in rightBottomNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" @click="selectGroup(num)">{{ num }}</div>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="6" style="text-align: right">
          随访开始日期：
        </a-col>
        <a-col :span="18">
          <a-date-picker value-format='YYYY-MM-DD' v-model="baseDate" />
        </a-col>
      </a-row>
      <!-- <a-row>
        <a-col :span="6" style="text-align: right;">
          {{this.period.groupTypeName||'分组'}}：
        </a-col>
        <a-col :span="18" style="margin-bottom: 16px">
          <a-select v-model="addGroupName" style="min-width:150px;" allow-clear showSearch>
            <a-select-option :value="item.text" v-for="(item,index) in enableAddGroupList" :key="index" >
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" style="text-align: right">
          随访开始日期：
        </a-col>
        <a-col :span="18">
          <a-date-picker value-format='YYYY-MM-DD' v-model="baseDate" />
        </a-col>
      </a-row> -->
    </a-modal>
    <a-modal
        :title="`修改访视日期`"
        :confirmLoading='loading'
        :width="400"
        :visible="editPeriodDate"
        @ok="editPeriodDateOk"
        @cancel="editPeriodDate = false">
        <a-form-model layout="vertical" :rules="rules">
          <a-form-model-item label="周期">
            {{copyPeriodItem?copyPeriodItem.name:''}}
          </a-form-model-item>          
          <a-form-model-item label="访视日期" prop="periodDate">
            <a-date-picker value-format='YYYY-MM-DD' v-model="editNewPeriodDate" /> 
          </a-form-model-item>    
        </a-form-model>          
      </a-modal>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import FollowPeriodCard from './followperiod/FollowPeriodCard'
import FormTable from './followperiod/FormTable'
import TrendModal from './followperiod/TrendModal'
import PeriodModal from './followperiod/addperiod/PeriodModal'
import PatientInfoCard from './PatientInfoCard'
import PatientEdit from './PatientEdit'
import StatusTag from './StatusTag'
import CustomPie from './CustomPie'
import PeriodStatusTag from './followperiod/PeriodStatusTag'
import NewHeader from '@comp/pad/NewHeader'
import copy from '@comp/Icon/copy'
import deleteIcon from '@comp/Icon/deleteIcon'
import edit from '@comp/Icon/edit'
import baseRules from '@/constants/baseRules'
export default {
  name: 'FollowPeriod',
  components: { StatusTag, PatientEdit, PatientInfoCard, PeriodModal, TrendModal, FormTable, FollowPeriodCard,PeriodStatusTag, CustomPie,NewHeader,copy,deleteIcon,edit, },
  props: {
    patient: {
      type: Object,
      default: () => {
        return {}
      }
    },
    projectPeriod: {
      type: Object,
      default: () => {
        return {}
      }
    },
    loadPatient: {
      type: Function,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      cur: 0,
      baseDateView: false,
      loading: false,
      fieldList: [],
      fieldList2: [],
      selectedKey: '',
      followList: [],
      formList: [],
      baseDate: '',
      isPad: this.$route.fullPath.startsWith('/pad'),
      cachePeriodKEY: 'CACHE_PERIOD_LOAD_INFO',
      teleTypeList:[
        {value:'1',text:'本人'},
        {value:'2',text:'配偶'},
        {value:'3',text:'子女'},
        {value:'4',text:'父母'},
        {value:'5',text:'朋友'},
        {value:'6',text:'其他亲戚'},
        {value:'9',text:'其他'},
      ],
      copyPeriodView:false,  
      editPeriodView:false,
      markPeriodView:false,
      editPeriodDate:false,
      copyPeriodItem:null,    
      followPeriodDate:undefined,
      editNewPeriodDate:undefined,
      copyPeriodName:'',
      editPeriodName:'',
      startGroupX: 0,
      startGroupLeft: 0,
      period:{},
      groupTypeView:false,
      tabActiveKey: 0,
      followGroupPeriodList:[],
      addGroupName:'',
      rules: {
        periodDate: [baseRules.required],
      },
      leftTopNumbers: [17, 16, 15, 14, 13, 12, 11],
      leftBottomNumbers: [47, 46, 45, 44, 43, 42, 41],
      rightTopNumbers: [21, 22, 23, 24, 25, 26, 27],
      rightBottomNumbers: [31, 32, 33, 34, 35, 36, 37],
      endPeriodList: [],
      endPeriodView:false,

    }
  },
  computed: {
    followGroupList () {
        let group = []
        this.followList.forEach(period=>{
          if(period.groupName && period.groupId && !group.some(item => item.groupId === period.groupId)){
            group.push({"groupId":period.groupId,"groupName":period.groupName,"groupStatus":period.groupStatus})
          }        
        });
        if(group.length>0){
          group.sort((a, b) => a.groupId - b.groupId);
        }
        return group
      },
      periodList(){
        return this.period.groupSet ==='0'?this.followList:this.followGroupPeriodList
      },
      enableAddGroupList(){
        let groups = this.period.dictItemList||[]
        let temps = []
        // let exists = this.followGroupList
        groups.forEach(g=>{
          // if(exists.indexOf(g.text)<0){
            temps.push(g)
          // }
        })
        return temps;
      }, 
  },
  mounted() {
    if (this.isPad && sessionStorage.getItem(this.cachePeriodKEY)) {
      // 缓存
      // this.selectedKey = sessionStorage.getItem(this.cachePeriodKEY)
    }
    this.loadData()
    getAction('/project/projectPatientField/list', { projectId: this.patient.projectId }).then(res => {
      if (res.success) {
        this.fieldList = res.result
      }
    })

    getAction('/patient/patientFieldValue/listAll', { patientId: this.patient.id, type: '2' }).then(res => {
      if (res.success) {
        this.fieldList2 = res.result
      }
    })    

    // this.$nextTick(() => {
    //   this.$refs.tabHeader2.addEventListener('touchstart', this.handleTouchStart);
    //   this.$refs.tabHeader2.addEventListener('touchmove', this.handleTouchMove);
    //   this.$refs.tabHeader2.addEventListener('touchend', this.handleTouchEnd);
    //   console.log("touchstart--------------")
    // });
  },
  beforeDestroy() {
    // this.$refs.tabHeader2.removeEventListener('touchstart', this.handleTouchStart);
    // this.$refs.tabHeader2.removeEventListener('touchmove', this.handleTouchMove);
    // this.$refs.tabHeader2.removeEventListener('touchend', this.handleTouchEnd);
  },
  methods: {
    loadTableData() {
      this.handleChange()
    },    
    getSelectRowsInfo() {
      return this.$refs['form-table'].getSelectRowsInfo()
    },
    handleView() {
      this.$refs['patient-edit'].view(this.patient)
    },
    loadPeriod(callBack){
        getAction('/project/projectPeriod/getPeriodDetail',{projectId:this.patient.projectId}).then(res=>{
          if(res.success){
            this.period = res.result
            if(this.period.groupSet==='0'){
              console.log("loadPeriod-callBack")
              callBack()              
            }else{
              this.groupChange(this.tabActiveKey)
            }
          }
        })
      },
    groupTypeHandle(){
      this.addGroupName =''
      this.groupTypeView=true
    },
    loadData() {
      getAction('/patient/patientPeriodItem/list', { patientId: this.patient.id }).then(res => {
        if (res.success) {          
          this.followList = res.result
          this.loadPeriod(m=>{
          if (this.followList.length > 0) {
            console.log("---------")
            if (!this.selectedKey) {
              if(this.patient.inPeriodItemIds){//受试者当前的访视周期
                let periodIds = this.patient.inPeriodItemIds.split(",");
                // let periodId = periodIds[periodIds.length-1]
                let periodId = periodIds[0] // 修改为默认展示未完成的第一个周期
                let follow
                let index = 0;
                for (let i = 0; i < this.followList.length; i++) {
                    if (this.followList[i].periodItemId === periodId) {
                    follow = this.followList[i]
                    break
                  }
                  index++
                }
                if (follow) {                  
                  this.selectChange(follow)
                  this.cur = index
                  return
                }
              }
              this.selectChange(this.followList[0])
            } else {
              let follow
              this.followList.forEach(item => {
                if (item.id === this.selectedKey) {
                  follow = item
                }
              })
              if (follow) {
                this.selectChange(follow)
              }
              else {
                this.selectChange(this.followList[0])
              }
            }
          }
          })       
        }
      })
    },
    statusClick(){
      console.log("statusClick")
      if(this.patient.status != '4'){
        return
      }
      getAction('/patient/patientEndPeriod/list', { patientId: this.patient.id }).then(res => {
        if (res.success) {
          this.endPeriodList = res.result
          if(this.endPeriodList.length > 0){
            this.endPeriodView = true
          }
        }
      })
    },
    startPeriodHandle() {
      this.baseDateView = true
    },
    startPeriodOk() {
      if (!this.baseDate) {
        return this.$message.warning('请选择基点日期')
      }
      this.loading = true
      postAction('/patient/patient/startPeriod', { id: this.patient.id, baseDate: this.baseDate }).then(res => {
        if (res.success) {
          this.baseDateView = false
          this.loadData()
          this.loadPatient()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    selected(item) {
      return this.selectedKey === item.id
    },
    selectChange(item) {
      this.selectedKey = item.id
      // sessionStorage.setItem(this.cachePeriodKEY, item.id)
      this.handleChange()
      //将当前周期id发送给父组件
      this.$emit('currentPeriodId', this.selectedKey);
    },
    handleChange() {
      this.loading = true
      getAction('/patient/patientForm/list', { periodItemId: this.selectedKey }).then(res => {
        if (res.success) {
          let i =0
            res.result.forEach(row => {
              if(!!row.children && row.children.length > 0){
                this.$set(row, 'id', "parent"+i);
                i++
              }
            })
          this.formList = res.result
        }
      }).finally(() => {
        this.loading = false
      })
    },
    trendView() {
      this.$refs['trendModal'].view()
    },
    handleAddPeriod() {
      this.$refs.periodModal.add()
    },
    getCurrentPeriod() {
      let current = {}
      this.followList.forEach(item => {
        if (item.id === this.selectedKey) {
          current = item
        }
      })
      return current
    },
    handleEditPeriod() {
      const current = Object.assign({}, this.getCurrentPeriod());

      this.$refs.periodModal.edit(current, this.formList)
    },
    getIdcardStr() {
      let value = '*****'
      if (this.patient.idcard) {
        if (this.patient.idcard.length > 4) {
          value = '*' + this.patient.idcard.substring(this.patient.idcard.length - 4, this.patient.idcard.length)
        }
      }
      return value
    },
    getteleTypeName(type){
      let typeName='无'
      this.teleTypeList.forEach(item=>{
        if(item.value===type){
          typeName = item.text+'联系方式'
        }
      })
      return typeName
    },
    copyPeriod(item){
      this.copyPeriodItem = item
      console.log("copy periodId:"+ item.id)
      this.copyPeriodView = true
    },
    editPeriod(item){
        console.log("edit periodId:"+ item.id)
        this.copyPeriodItem = item
        this.editPeriodName = item.name
        this.editPeriodView = true
      },
    editPeriodMark(item){
      console.log("mark periodId:"+ item.id)
        this.copyPeriodItem = item
        this.markPeriodView = true
    },
    editPeriodVisitDate(item){
      this.copyPeriodItem = item
      this.editPeriodDate = true
      this.getCurrentDate()
    },  
    delPeriod(item){
      console.log("del periodId:"+ item.id)
      this.$confirm({
          title: '删除周期',
          content: (<div>
            <p>您确定要删除周期【{item.name}】吗？</p>
            <p style="color:red;">注意：删除后将同时删除采集的表单数据，无法恢复，请谨慎操作！</p>
          </div>),
          centered: false,
          onOk: () => {
            getAction("/patient/patientPeriodItem/delPeriod",{id:item.id}).then((res) => {
              if (res.success) {
                this.$message.success(res.message)                
                this.loadData()
              } else {
                this.$message.warning(res.message);
              }
            });
          },
        })
    },
    copyPeriodOk(){
      if(!this.copyPeriodItem){
        return
      }
      if(!this.followPeriodDate){
        this.$message.warning("请选择访视日期");
        return
      }
      this.loading = true
      const that = this;
      getAction("/patient/patientPeriodItem/copyPeriod",{id:this.copyPeriodItem.id,visitDate:this.followPeriodDate,copyPeriodName:this.copyPeriodName}).then((res) => {
              if (res.success) {
                this.$message.success(res.message)                
                that.loadData()                
              } else {
                this.$message.warning(res.message);
              }
            }).finally(()=>{
              this.loading= false
              this.copyPeriodView = false
            });
    },
    editPeriodOk(){
        if(!this.editPeriodName){
          this.$message.warning("周期名称不能为空");
          return
        }
        this.loading = true
        const that = this;
        getAction("/patient/patientPeriodItem/editPeriod",{id:this.copyPeriodItem.id,editPeriodName:this.editPeriodName}).then((res) => {
              if (res.success) {
                this.$message.success(res.message)                
                that.loadData()
              } else {
                this.$message.warning(res.message);
              }
            }).finally(()=>{
              this.loading= false
              this.editPeriodView = false
            });
      },
      markPeriodOk(){        
        this.loading = true
        const that = this;
        getAction("/patient/patientPeriodItem/editPeriodMark",{id:this.copyPeriodItem.id,remark:this.copyPeriodItem.remark}).then((res) => {
              if (res.success) {
                this.$message.success(res.message)                
                that.loadData()
              } else {
                this.$message.warning(res.message);
              }
            }).finally(()=>{
              this.loading= false
              this.markPeriodView = false
            });
      },
    handleTouchStart(e) {
      this.startGroupX = e.touches[0].clientX;
      this.startGroupLeft = this.$refs.tabHeader2.scrollLeft;
    },
    handleTouchMove(e) {
      const moveX = e.touches[0].clientX - this.startGroupX;
      this.$refs.tabHeader2.scrollLeft = this.startGroupLeft - moveX;
    },
    handleTouchEnd() {
    },
    groupChange(key){
      console.log("key:"+key)
        if(this.followGroupList && this.followGroupList.length>0){
          if(key>this.followGroupList.length-1){
            key = 0
            this.tabActiveKey = key
          }
          this.followGroupPeriodList = this.followList.filter(period=>period.groupId===this.followGroupList[key].groupId)
          this.selectChange(this.followGroupPeriodList[0])
          this.cur = 0
        }
      },
    //给受试者添加分组周期
      groupTypeOk(){
        let groupType = this.period.groupTypeName || '分组'
        if(!this.addGroupName){          
          return this.$message.warning('请选择'+groupType)
        }
        if(!this.baseDate){
          return this.$message.warning('请选择随访日期')
        }
        this.loading = true
        this.addGroupName = groupType+this.addGroupName
        postAction('/patient/patient/addGroupPeriod',{patientId:this.patient.id,baseDate:this.baseDate,groupName:this.addGroupName}).then(res=>{
          if(res.success){
            this.groupTypeView=false            
            this.loadData()
            this.loadPatient()
            this.baseDate=''
            this.addGroupName=''
            this.tabActiveKey = 0
          }else{
            this.addGroupName=''
            this.$message.warning(res.message)
          }
        }).finally(()=>{
          this.addGroupName=''
          this.loading = false
        })
      },
      renderTab(pane) {
        const warningMark = pane.groupStatus==='2' ? (
          <a-tooltip placement="topLeft">
            <template slot="title">
              已终止随访
            </template>
            <a-icon type="info-circle" style="color: #FF4500; margin-right:3px" />
          </a-tooltip>
        ) : null;
        return (
          <span>
            {warningMark}
            {pane.groupName}            
          </span>
        );
      },
      editPeriodDateOk(){
        if(!this.editNewPeriodDate){
          this.$message.warning("请选择访视日期");
          return
        }
        
        this.loading = true
        const that = this;       
        postAction('/patient/patient/updateVisitDate', { periodItemId: this.copyPeriodItem.id, periodItemDate: this.editNewPeriodDate }).then(res => {
          if (res.success) {            
            this.$message.success(res.message)
            this.editPeriodDate = false
            that.loadData()
          }else {
            this.$message.warning(res.message);
          }
          }).finally(()=>{
            this.loading = false            
          });        
      },
      getCurrentDate() {
        const today = new Date();
        // 格式化日期为 YYYY-MM-DD 格式
        this.editNewPeriodDate = today.getFullYear() + '-' +
                          ('0' + (today.getMonth() + 1)).slice(-2) + '-' +
                          ('0' + today.getDate()).slice(-2);
      },
      selectGroup(num){
        this.addGroupName = num
      },
  }
}
</script>

<style scoped lang="less">
@color1: rgba(55, 110, 255, 1);

.box {
  width: 100vw;
  overflow: hidden;
  .wrap{
    padding: 20px;
  }
  .top1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 12px;

    .left {
      display: flex;

      .info {
        margin-left: 20px;

        .detail {
          display: flex;
          align-items: center;

          strong {
            font-weight: 600;
            font-size: 16px;
            color: #48494D;
            margin-right: 6px;
          }
        }

        .serial-number {
          font-weight: 400;
          font-size: 12px;
          color: #77797E;
          line-height: 30px;
        }
      }
    }

    .middle {
      flex: 1;
      padding: 0 30px;

      .row1 {

        span,
        strong {
          display: block;
        }
      }
    }

    .right {
      button {
        width: 98px;
        height: 38px;
        color: #376EFF;
        border-radius: 8px;
        border: 1px solid #C3D4FF;
      }
    }
  }

  .line {
    height: 1px;
    background-color: #DFE1E5;
    margin: 20px 0;
  }

  .main {
    height: calc(100vh - 217px);
    display: flex;
    align-items: stretch;

    .left::-webkit-scrollbar,
    .right::-webkit-scrollbar
    {
      display: none;
    }

    .left {
      overflow: auto;
      
      .item:last-child{
        margin-bottom: 0;
      }
      .item {
        position: relative;
        width: 300px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 12px;
        border: 2px solid transparent;
        margin-bottom: 20px;
        cursor: pointer;
        .info {
          position: absolute;
          top:16px;
          left: 88px;
          .title {
            font-weight: 600;
            font-size: 16px;
            color: #48494D;
          }

          .status {
            display: flex;
            align-items: center;
            padding: 0;

            .sp1 {
              font-weight: 400;
              font-size: 12px;
              color: #B4B7BF;
              line-height: 14px;
            }

            .sp2 {
              font-weight: 600;
              font-size: 14px;
              color: #48494D;
              margin: 0 10px;
            }

            .sp3 {
              width: 43px;
              height: 17px;
              line-height: 17px;
              text-align: center;
              font-weight: 400;
              font-size: 11px;
              color: #FFFFFF;
              background: #30C6CB;
              border-radius: 31px 31px 31px 31px;
            }
          }

          .time {
            span {
              font-weight: 400;
              font-size: 12px;
              color: #B4B7BF;
              margin-right: 10px;
            }

            strong {
              font-weight: 600;
              font-size: 12px;
              color: #48494D;
            }
          }
        }
      }
      .cur{
        border: 2px solid rgba(55, 110, 255, 1);
      }
    }

    .line-vertical {
      width: 1px;
      background-color: #DFE1E5;
      margin: 0 20px;
    }

    .right {
      flex: 1;
      overflow: auto;

      .btn {
        text-align: right;

        button {
          // width: 130px;
          height: 40px;
          margin-left: 20px;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
          background: #376EFF;
          border-color: #376EFF;
          border-radius: 8px 8px 8px 8px;

        }
      }
    }

  }
}

.follow-row {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
}

.panel {
  margin-top: 10px;
}

.patient-info-card {
  margin: 5px;
}
// #copyIcon{
//   position: absolute;
//   left:82%;
//   top:0.8%;
// }
// #delIcon{
//   position: absolute;
//   left:90%;
//   top:0.8%;
// }
// #editIcon{
//   position: absolute;
//   left:74%;
//   top:0.8%;
// }
.icon-container {
  display: flex;
  justify-content: flex-end; /* 让所有图标向右对齐 */  
  gap: 5px; /* 图标之间的间距 */
  position: absolute;
  top: -1px;
  right: 6px;
}
.icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-size: cover;
}
.tab-container2 {
  overflow: hidden;
  width:300px;
}
.tab-header2 {
  overflow-x: auto;
  white-space: nowrap;
}
.number-cell {
    text-align: center;
    line-height: 30px; /* 根据需要调整 */
    border: 1px solid #ccc; /* 添加边框 */
    margin-bottom: 8px; /* 调整间距 */
    border-radius: 10px; /* 添加圆角 */
  }
  /* 悬停状态 */
        .number-cell:hover {
            background: #b9babb;
            border-color: #c0c4cc;
            cursor: pointer;
        }

        /* 选中状态 */
        .number-cell.active {
            background: #409eff;
            color: white;
            border-color: #409eff;
        }
.filtrate-fail {
    border: 0.5px solid rgba(221, 51, 55, 0.5);
    margin-top: 0px;
    padding: 10px;
    background-color: #FFF1F0;

    .fail-title {
      font-size: 16px;
    }

    .fail-info {
      margin-left: 20px;
    }
  }
</style>